// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    position: fixed;
    background: #FCF9F7;
    display: flex;
    width: 100%;
    height: 100vh;
}

.Setting_User_Attribute {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
}

.smallImgCircle {
    border-radius: 100% !important;
    overflow: hidden;
    width: 80px;
    height: 80px;
    border: 2px solid rgba(255, 255, 255, 0.2);
}

.smallImgCircle>img {
    width: 100%;
    height: 100%;
}

.PermissionHeader {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 24px;
}

.PermissionHeader>.Details {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.permission_user_name {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #3F3325;
}

.Permission_Title {
    width: 20%;
}

.Permission_Title>span {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #3F3325;
}

.Permission {
    display: flex;
    gap: 38px;
}


.permissionContent {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.permission_email_name {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #594F42;
}

.ImgCircle {
    border-radius: 100% !important;
    overflow: hidden;
    width: 128px;
    height: 128px;
    border: 2px solid rgba(255, 255, 255, 0.2);
}

.ImgCircle>img {
    width: 100%;
    height: 100%;
}

.ImgEdit {
    display: flex;
    height: 100%;
    align-items: baseline;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/CSS/User.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,qBAAqB;IACrB,eAAe;AACnB","sourcesContent":[".container {\n    position: fixed;\n    background: #FCF9F7;\n    display: flex;\n    width: 100%;\n    height: 100vh;\n}\n\n.Setting_User_Attribute {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n}\n\n.smallImgCircle {\n    border-radius: 100% !important;\n    overflow: hidden;\n    width: 80px;\n    height: 80px;\n    border: 2px solid rgba(255, 255, 255, 0.2);\n}\n\n.smallImgCircle>img {\n    width: 100%;\n    height: 100%;\n}\n\n.PermissionHeader {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 24px;\n}\n\n.PermissionHeader>.Details {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.permission_user_name {\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 20px;\n    color: #3F3325;\n}\n\n.Permission_Title {\n    width: 20%;\n}\n\n.Permission_Title>span {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #3F3325;\n}\n\n.Permission {\n    display: flex;\n    gap: 38px;\n}\n\n\n.permissionContent {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.permission_email_name {\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 18px;\n    color: #594F42;\n}\n\n.ImgCircle {\n    border-radius: 100% !important;\n    overflow: hidden;\n    width: 128px;\n    height: 128px;\n    border: 2px solid rgba(255, 255, 255, 0.2);\n}\n\n.ImgCircle>img {\n    width: 100%;\n    height: 100%;\n}\n\n.ImgEdit {\n    display: flex;\n    height: 100%;\n    align-items: baseline;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
